import React from "react";
import Seo from "../components/Seo";
import Layout from "../layouts/sample";
import {Button} from "../components/global/Button";


const NotFoundPage = () => {
  return (
    <Layout>
      <section className="pt-14-rem pb-lg-21 pb-md-11 pb-11">
        <div className="container">
          <div className="row">
            <div className="col-xl-5 col-lg-6 col-10">
              <h1 className="mb-lg-5 mb-md-7 mb-6 d-inline-flex flex-wrap align-items-start h2 letter-spacing-4">
                <span>Oops, page</span>
                <span className="zg-label bg-purple mx-2 mt-2">404</span>
                <span>not found</span>
              </h1>
            </div>
            <div className="col-xl-4 col-lg-5 col-md-10 offset-lg-1">
              <p className="mb-7">The page you were looking for could not be found. It might have been removed, or
                didn’t exist.</p>
              <Button
                title="Back to Home page"
                url='/'
                classes="btn-lg w-sm-100"
              />
            </div>
          </div>
        </div>
      </section>
    </Layout>

  )
}

export default NotFoundPage

export const Head = () => <Seo title="Not found"/>;
